/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/recurring_run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1RecurringRun } from './V2beta1RecurringRun';
import {
  V2beta1RecurringRunFromJSON,
  V2beta1RecurringRunFromJSONTyped,
  V2beta1RecurringRunToJSON,
  V2beta1RecurringRunToJSONTyped,
} from './V2beta1RecurringRun';

/**
 *
 * @export
 * @interface V2beta1ListRecurringRunsResponse
 */
export interface V2beta1ListRecurringRunsResponse {
  /**
   * A list of recurring runs returned.
   * @type {Array<V2beta1RecurringRun>}
   * @memberof V2beta1ListRecurringRunsResponse
   */
  recurringRuns?: Array<V2beta1RecurringRun>;
  /**
   * The total number of recurring runs for the given query.
   * @type {number}
   * @memberof V2beta1ListRecurringRunsResponse
   */
  total_size?: number;
  /**
   * The token to list the next page of recurring runs.
   * @type {string}
   * @memberof V2beta1ListRecurringRunsResponse
   */
  next_page_token?: string;
}

/**
 * Check if a given object implements the V2beta1ListRecurringRunsResponse interface.
 */
export function instanceOfV2beta1ListRecurringRunsResponse(
  value: object,
): value is V2beta1ListRecurringRunsResponse {
  return true;
}

export function V2beta1ListRecurringRunsResponseFromJSON(
  json: any,
): V2beta1ListRecurringRunsResponse {
  return V2beta1ListRecurringRunsResponseFromJSONTyped(json, false);
}

export function V2beta1ListRecurringRunsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1ListRecurringRunsResponse {
  if (json == null) {
    return json;
  }
  return {
    recurringRuns:
      json['recurringRuns'] == null
        ? undefined
        : (json['recurringRuns'] as Array<any>).map(V2beta1RecurringRunFromJSON),
    total_size: json['total_size'] == null ? undefined : json['total_size'],
    next_page_token: json['next_page_token'] == null ? undefined : json['next_page_token'],
  };
}

export function V2beta1ListRecurringRunsResponseToJSON(
  json: any,
): V2beta1ListRecurringRunsResponse {
  return V2beta1ListRecurringRunsResponseToJSONTyped(json, false);
}

export function V2beta1ListRecurringRunsResponseToJSONTyped(
  value?: V2beta1ListRecurringRunsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    recurringRuns:
      value['recurringRuns'] == null
        ? undefined
        : (value['recurringRuns'] as Array<any>).map(V2beta1RecurringRunToJSON),
    total_size: value['total_size'],
    next_page_token: value['next_page_token'],
  };
}
